{
  "BL": {
    "domain": {
      "nonProd": "https://ppe-commercial-agent.libertymutual.com",
      "prod": "https://commercial-agent.libertymutual.com"
    },
    "axisBaseURL": {
      "prod": "https://commercial-service-agent.libertymutual.com",
      "nonProd": "https://axis-qa.lmig.com"
    },
    "wasPortal": {
      "agent": {
        "nonProd": "https://stage-agentsportal.libertymutual.com",
        "prod": "https://agentsportal.libertymutual.com"
      },
      "employee": {
        "nonProd": "https://stage-lramportal.lmig.com",
        "prod": "https://lramportal.lmig.com"
      }
    },
    "arrangeFinancials": "af.libertymutual.com",
    "quote": {
      "agent": {
        "nonProd": "https://stage-bi-quote.libertymutual.com/gw/menu",
        "prod": "https://eclps.libertymutual.com/cliq/MainMenu.action"
      },
      "employee": {
        "nonProd": "https://stage-bi-quote.lmig.com/gw/menu",
        "prod": "https://eclps.lmig.com/cliq/MainMenu.action"
      }
    },
    "userIdSuffix": {
      "nonProd": "@ciportal.capnp.lmig.com",
      "prod": "@ciportal.cap.lmig.com"
    },
    "logoutPage": "/Admin/bl/Logout",
    "isi": {
      "nonProd": "https://test-instantincentives.libertymutual.com/",
      "prod": "https://instantincentives.libertymutual.com/"
    },
    "pingLogoutLink": {
      "nonProd": "https://np-lmidp-smtoken.libertymutual.com/logoff.html",
      "prod": "https://prod-lmidp-smtokenext.libertymutual.com/logoff.html"
    },
    "wasLogoutLink": {
      "nonProd": "https://stage-agentsportal.libertymutual.com/portal/logout?Sys=ciportal",
      "prod": "https://agentsportal.libertymutual.com/portal/logout?Sys=ciportal"
    },
    "settingsLink": {
      "nonProd": "https://test-eservices-kc.lmig.com/EDA/enduser/Start.do?logo=libertymutual",
      "prod": "https://eservices-kc.lmig.com/EDA/enduser/Start.do?logo=libertymutual"
    },
    "manageIdPasswordLink": {
      "nonProd": "https://test-eservices-kc.lmig.com/EDA/enduser/Start.do?logo=libertymutual",
      "prod": "https://eservices-kc.lmig.com/EDA/enduser/Start.do?logo=libertymutual"
    },
    "smartworksMRCSSOURL": {
      "nonProd": "https://env1.smartworks.com",
      "prod": "https://login6.smartworks.com"
    },
    "userRegistration": {
      "nonProd": "https://test-eservices.lmig.com/DUR/userregistration.do",
      "prod": "https://eservices.lmig.com/DUR/userregistration.do"
    },
    "forgotPassword": {
      "prod": "http://bl-identity.libertymutual.com/forgotPassword",
      "nonProd": "https://stage-bl-identity.libertymutual.com/forgotPassword"
    },
    "premiumAuditLink": {
      "prod": "https://premiumaudit.lmig.com/agent",
      "nonProd": "https://premiumaudit-staging.lmig.com/agent"
    },
    "appetite": {
      "prod": "https://bi-quote.libertymutual.com/gw/menu/appetite",
      "nonProd": "https://stage-bi-quote.libertymutual.com/gw/menu/appetite"
    },
    "ecliq": {
      "prod": "https://eclps.libertymutual.com/cliq/MainMenu.action",
      "nonProd": "https://stage-eclps.libertymutual.com/cliq/MainMenu.action"
    }
  },
  "PL": {
    "domain": {
      "nonProd": "https://ppe-personal-agent.libertymutual.com",
      "prod": "https://personal-agent.libertymutual.com"
    },
    "userIdSuffix": {
      "nonProd": "@safeconow.capnp.lmig.com",
      "prod": "@safeconow.cap.lmig.com"
    },
    "logoutPage": "/admin/pl/Logout",
    "settingsLink": "/MyWork/Settings",
    "recentActivitiesLink": {
      "nonProd": "https://ppe-personal-agent-recent-activities.libertymutual.com",
      "prod": "https://personal-agent-recent-activities.libertymutual.com"
    },
    "mmr": {
      "nonProd": {
        "agent": "https://service-test.agent.libertymutual.com",
        "employee": "https://crest-ui-test.lmig.com"
      },
      "prod": {
        "agent": "https://service.agent.libertymutual.com",
        "employee": "https://crest-ui.lmig.com"
      }
    },
    "isi": {
      "nonProd": "https://test-personal-instantincentives.libertymutual.com",
      "prod": "https://personal-instantincentives.libertymutual.com"
    },
    "pstLink": {
      "nonProd": "https://personal.qa.libertymutual.com/personal/TACRC/pst/inquiry.aspx",
      "prod": "https://personal.libertymutual.com/personal/pst/inquiry.aspx"
    },
    "secureUploadLink": {
      "nonProd": "https://test-secureupload.libertymutual.com",
      "prod": "https://secureupload.libertymutual.com"
    },
    "billingPaymentServicesLink": {
      "nonProd": "https://safesite.qa.safeco.com/personal/billing/tacml/billing/welcome.aspx",
      "prod": "https://safesite.safeco.com/personal/billing/welcome.aspx"
    },
    "clientList": {
      "nonProd": "https://client.qa.libertymutual.com/Client/Clientlist.aspx",
      "prod": "https://client.libertymutual.com/Client/clientlist.aspx"
    },
    "clientListDeepLink": {
      "nonProd": "https://client.qa.safeco.com/client/tacml/Client/OpenActivity.aspx",
      "prod": "https://client.safeco.com/client/OpenActivity.aspx"
    },
    "cfb": {
      "nonProd": "https://safesite.qa.safeco.com/ss/cfb/default.asp?target=summary.asp&appid=CFB&appurl=&searchall=All",
      "prod": "https://safesite.safeco.com/ss/cfb/default.asp?target=summary.asp&appid=CFB&appurl=&searchall=All"
    },
    "forgotPassword": {
      "nonProd": "https://test-open.libertymutual.com/forgotpassword",
      "prod": "https://open.libertymutual.com/forgotpassword"
    },
    "ChatUI": {
      "prod": "https://omni-chat-ui.libertymutual.com/v1/bootstrap/chat-bootstrap.js",
      "nonProd": "https://nonprod-omni-chat-ui.libertymutual.com/v1/bootstrap/chat-bootstrap.js"
    }
  },
  "Public": {
    "domain": {
      "dev": "https://public.agent.dev.libertymutual.com",
      "int": "https://int-agent.public.libertymutual.com",
      "ppe": "https://ppe-agent.public.libertymutual.com",
      "prod": "https://agent.public.libertymutual.com"
    }
  },
  "CustomerSearch": {
    "path": "/mywork/mywork",
    "searchParams": "command=LoadCustomerAsSearch&type=glb&keyword="
  },
  "Coveo": {
    "searchPage": "/search/results"
  },
  "MiddleMarketUrl": {
    "prod": "https://account.libertymutual.com",
    "nonProd": "https://account-staging.libertymutual.com"
  },
  "SuretyUrl": {
    "prod": "https://agents.libertymutualsurety.com/surety",
    "nonProd": "https://staging-agents.libertymutualsurety.com/surety"
  },
  "StateAutoUrl": {
    "prod": "https://saconnect.stateauto.com/",
    "nonProd": "https://saconnect-l3-5.stateauto.com/"
  },
  "pingLogoutIFrameURL": {
    "nonProd": "https://test-lmidp.libertymutual.com/idp/startSLO.ping",
    "prod": "https://lmidp.libertymutual.com/idp/startSLO.ping"
  }
}